// ["editing", "proofreading", "finalcheck", "approved", "rejected"]]
export const getUpdateStatus = (status: string) => {
  switch (status) {
    case 'editing':
      return 'proofreading';
    case 'proofreading':
      return 'finalcheck';
    case 'finalcheck':
      return 'approved';
    default:
      return '';
  }
};

export const getBtnText = (status: string) => {
  switch (status) {
    case 'editing':
      return 'Edited';
    case 'proofreading':
      return 'Proofread';
    case 'finalcheck':
      return 'Ready to go';
    case 'rejected':
      return '';
    default:
      return '';
  }
};

export const getBtnColor = (status: string) => {
  switch (status) {
    case 'editing':
      return '#F2994A';
    case 'edited':
      return '#F2994A';
    case 'proofreading':
      return 'green';
    case 'approved':
      return 'green';
    case 'rejected':
      return 'red';
    default:
      return 'green';
  }
};
